class FormShower {
  constructor() {
    this.form = document.querySelector('.zoomForm')
    this.currentContent
    this.currentTab
    this.listen()
  }

  listen() {
    document.addEventListener('click', (ev) => {
      if (ev.target.id == "hubspot_form_button" || ev.target.classList.contains('button--register')) {
        // if form is open, close it
        let oldForm = document.querySelector('.zoomForm:not(.zoomForm--hidden)')
        if (oldForm) {
          let oldButton = document.querySelector('.button--register.button--active')
          if (oldButton) {
            oldButton.classList.remove('button--active')
          }
          oldForm.classList.add('zoomForm--hidden')
          this.hideForm()
        }
        this.button = ev.target
        this.button.classList.toggle('button--active')
        if (this.button.classList.contains('button--active')) {
          if (this.button.getAttribute('id')) {
            let selector = document.querySelectorAll('.zoomForm')
            this.form = selector[selector.length -1]
          } else {
            this.form = document.querySelector(`#form_${this.button.dataset.form}`)
          }
          this.form.classList.remove('zoomForm--hidden')
          this.showForm()
          return
        }
        this.hideForm()
      }
    })
  }

  showForm() {
    this.currentContent = document.querySelector('.event__tab--active')
    if (this.currentContent) {
      this.currentContent.classList.remove('event__tab--active')
    }
    this.currentTab = document.querySelector('.eventTabs__tab--active')
    if (this.currentTab) {
      this.currentTab.classList.remove('eventTabs__tab--active')
    }
  }

  hideForm() {
    if (this.currentContent) {
      this.currentContent.classList.add('event__tab--active')
    }
    if (this.currentTab) {
      this.currentTab.classList.add('eventTabs__tab--active')
    }
  }

}

export default FormShower